var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app","hidden":""}},[_c('v-main',{class:!this.$vuetify.theme.dark ? 'grey lighten-3' : ''},[_c('router-view',{staticClass:"mt-n1"}),_c('support-dialog'),_c('confirm-dialog')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }